import React from "react";

import Tag from "antd/es/tag";
import randomColor from "randomcolor";

import stringHash from "@mapmycustomers/shared/util/hash/stringHash";

import getBorderColor from "@app/util/colors/getBorderColor";
import getContrastColor from "@app/util/colors/getContrastColor";

import styles from "./OptionTag.module.scss";

// TODO: think about extracting this color-stuff in a separate file
const colorMap = new Map<string, string>();
const getColor = (key: string): string => {
  if (!colorMap.has(key)) {
    const color = randomColor({
      format: "rgb",
      luminosity: "bright",
      seed: stringHash(key) * 0xdeadbeef,
    });
    colorMap.set(key, color);
  }

  return colorMap.get(key) as string;
};

interface Props {
  fieldName: string;
  label: string;
  value: number;
}

const OptionTag: React.FC<Props> = ({ fieldName, label, value }) => {
  const key = `${fieldName}_${value}`;
  const backgroundColor = getColor(key);
  return (
    <Tag
      className={styles.container}
      style={{
        backgroundColor: backgroundColor,
        borderColor: getBorderColor(backgroundColor),
        color: getContrastColor(backgroundColor),
      }}
    >
      {label}
    </Tag>
  );
};

export default OptionTag;
